// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1sd2g","content":"LoadingAlert_content__3QEYv"};